//计算具体日期
function countDays(arr,days){
	var sum = 0;
	var month = 0;
	var monNum = 0;
	for(var i = 0 ; i < arr.length ; i++){
		sum += arr[i];
		if(sum > days){
			sum -= arr[i];
			month = i + 1;
			break;
		}
		if(sum == days){
			month = i + 1;
			monNum = arr[i];
			break;
		}
	}
	if(month <= 9){
		var day = days - sum;
		if(day <= 9 && day > 0){
			var countday = ("0"+month+"0"+day);
			return countday;
		}else if(day > 9){
			var countday = ("0"+month+""+day);
			return countday;
		}else if(day == 0){
			console.log("day=0");
			var countday = ("0"+month+""+monNum);
			return countday;
		}
	}else{
		var day = days - sum;
		if(day <= 9 && day > 0){
			var countday = (month+"0"+day);
			return countday;
		}else if(day > 9){
			var countday = (month+""+day);
			return countday;
		}else if(day == 0){
			var countday = (month+""+monNum);
			return countday;
		}
	}
}

//天数转为具体日期
function getDate(years,dates){
	var a = [31,28,31,30,31,30,31,31,30,31,30,31];
	var b = [31,29,31,30,31,30,31,31,30,31,30,31];
	 var nowDate = new Date();
	if(nowDate.getFullYear() % 4 == 0 && nowDate.getFullYear() % 100 != 0 || nowDate.getFullYear() % 400 == 0){
		var getDates = years + countDays(b,dates);
		console.log("1.1:"+getDates);
		return getDates;
	}else{
		var getDates = years + "" + countDays(a,dates);
		console.log("1.2:"+getDates);
		return getDates;
	}
}

//反向编码
function restore(text){
	console.log(text);
	var years  = Number(text.toString().substr(2,2));
	var dates  = Number(text.toString().substr(4,3));
	var orders = Number(text.toString().substr(7,3));
	// var years  = text.toString().substring(2,2);
	// datas  = text.substring(2,5);
	// orders = text.substring(5);
	console.log(years);
	console.log(dates);
	console.log(orders);
	if(dates > 400){
		orders += 999;
		dates = dates - 400;
		var restoreNum = getDate(years,dates) + orders;
		console.log("1:"+restoreNum);
		restoreNum = "A20"+restoreNum;
		return restoreNum;
	}else if(dates < 400){
		var restoreNum = getDate(years,dates) + orders;
		console.log("2:"+restoreNum);
		restoreNum = "A20"+restoreNum;
		return restoreNum;
	}
}

export {  //添加export抛出模块
    restore
}


// WEBPACK FOOTER //
// ./src/fetch/twocode.js